import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { FuaFormData } from 'components/Assessments/FuaAssessment/types/FuaFormData'
import { DischargePlanningFormField } from './formField'
import { DischargePlanningQuestionnaireItem } from './questionnaire'

/**
 * Discharge Planning subsection adapter for FUA Assessment
 * Handles discharge planning extraction and transformation
 */
export class DischargePlanningAdapter extends BaseSubsectionAdapter<FuaFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<FuaFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const dischargePlans = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS
    )?.at(0)
    const rehabilitationPotential = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL
    )?.at(0)
    const notes = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES
    )?.at(0)

    return {
      [DischargePlanningFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS]: dischargePlans,
      [DischargePlanningFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]:
        rehabilitationPotential,
      [DischargePlanningFormField.DISCHARGE_PLANNING_NOTES]: notes
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(DischargePlanningFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS)) {
      mutations.push({
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS,
        value: this.getFormDataField(DischargePlanningFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS)
      })
    }

    if (
      this.formDataFieldExists(
        DischargePlanningFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL
      )
    ) {
      mutations.push({
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL,
        value: this.getFormDataField(
          DischargePlanningFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL
        )
      })
    }

    if (this.formDataFieldExists(DischargePlanningFormField.DISCHARGE_PLANNING_NOTES)) {
      mutations.push({
        linkId: DischargePlanningQuestionnaireItem.DISCHARGE_PLANNING_NOTES,
        value: this.getFormDataField(DischargePlanningFormField.DISCHARGE_PLANNING_NOTES)
      })
    }

    return mutations
  }
}
